<template>
  <div>
    <el-row>
      <p
        :style="{
          textAlign: 'left',
          fontSize: '12px',
          margin: '8px 10px',
          fontWeight: 600,
        }"
      >
        门禁通过情况
      </p>
      <v-chart
        :style="{ height: '300px', width: '420px' }"
        :options="OutInData"
        :auto-resize="true"
        theme="macarons"
      ></v-chart>
    </el-row>

   
  </div>
</template>

<script>
import { getDoorTrendChart } from '@/api/business/beijing/door'
// 导入主题，引用时在v-chart中增加theme="macarons"
import "echarts/theme/macarons"

export default {
  props: {
    positionId: null
  },
  data() {
    return {
      OutInData: {},
      electricityTrendData: null,
      OldData: {},
      digitalMapId: null,
      queryArea: null,
      BillingData: null,
      deviceType01017: {
        monitorType002001: null,
        monitorType002002: null,
        monitorType002003: null,
      }
    };

  },
  computed: {
    positionIdChange() {
      
      return this.positionId
    }
  },
  watch: {
    positionIdChange() {
      console.log(this.positionId)
       this.getDoorTrendChart()
    }
  },
  created() {
    this.getDoorTrendChart()
  },
  methods: {
    getDoorTrendChart() {
      const params = {
      positionId: this.positionId
    }
    getDoorTrendChart(params).then(res => {
      this.getOutInData(res)
    })
    },
    getOutInData(res) {
      let option = {
        tooltip: {
          trigger: 'axis'       //触发类型；轴触发，axis则鼠标hover到一条柱状图显示全部数据，item则鼠标hover到折线点显示相应数据
        },
        legend: {
          // data: ['已占用车位数', '剩余车位数'],
          x: 'left',
        },
        toolbox: {          //工具栏
          show: true,
          feature: {
            mark: { show: true },   //辅助线标志
            dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ['line', 'bar'] },   //动态类型切换
            restore: { show: true },
            saveAsImage: { show: true }
          }
        },
        calculable: true,    //是否启用拖拽重计算特性，默认关闭
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,     //控制x轴的数值是否顶头，默认为true留空，false则顶头
            data: ["00", "02", "04", "06", "08", "10", "12", "14", "16", "18", "20", "22"]
          }
        ],
        yAxis: [
          {
            type: 'value',
            // max: max,
            axisLabel: {
              formatter: '{value}'      //formatter: '{value} °C',//轴上的数据带单位
            }
          }
        ],
        series: [
          {
            name: '门禁通过',
            type: 'line',    // 图表类型，折线图line、散点图scatter、柱状图bar、饼图pie、雷达图radar
            data: res.data,
            label: {
              show: true,
              position: "top",
              itemStyle: {
                normal: {
                  show: true,
                  fontSize: 8
                },
              },
            },
          },
          // {
          //   name: '剩余车位数',
          //   type: 'line',    // 图表类型，折线图line、散点图scatter、柱状图bar、饼图pie、雷达图radar
          //   data: data.map(v => max - v),
          //   label: {
          //     show: true,
          //     position: "top",

          //   },
          // },
        ]
      }
      this.OutInData = option
    },
    getBillingData() {
      let option = {
        tooltip: {
          trigger: 'axis'       //触发类型；轴触发，axis则鼠标hover到一条柱状图显示全部数据，item则鼠标hover到折线点显示相应数据
        },
        legend: {
          data: ['已收取费用（元）'],
          x: 'left',
        },
        toolbox: {          //工具栏
          show: true,
          feature: {
            mark: { show: true },   //辅助线标志
            dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ['line', 'bar'] },   //动态类型切换
            restore: { show: true },
            saveAsImage: { show: true }
          }
        },
        calculable: true,    //是否启用拖拽重计算特性，默认关闭
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,     //控制x轴的数值是否顶头，默认为true留空，false则顶头
            data: ["00", "02", "04", "06", "08", "10", "12", "14", "16", "18", "20", "22"]
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              formatter: '{value}'      //formatter: '{value} °C',//轴上的数据带单位
            }
          }
        ],
        series: [
          {
            name: '已收取费用',
            type: 'line',    // 图表类型，折线图line、散点图scatter、柱状图bar、饼图pie、雷达图radar
            data: [1, 0, 0, 4, 49, 24, 10, 11, 2, 12, 0, 0],
            markPoint: {
              data: [
                { type: 'max', name: '最大值' }
              ]
            }
          }
        ]
      }
      return option
    },
    getManualLiftData(getvalue) {
      return {
        title: [{
          text: '车位使用率（%）',
          x: 'center',
          textStyle: {
            fontSize: '16',
            color: '#333',
            foontWeight: '600',
          },
        }, {
          text: Math.round(getvalue) + '%',
          x: 'center',
          top: 'center',
          textStyle: {
            fontSize: '16',
            color: '#25BFFF',
            foontWeight: '600',
          },
        }],
        polar: {
          radius: ['40%', '65%'],
          center: ['50%', '50%'],
        },
        angleAxis: {
          max: 514,
          show: false,
        },
        radiusAxis: {
          type: 'category',
          show: true,
          axisLabel: {
            show: false,
          },
          axisLine: {
            show: false,

          },
          axisTick: {
            show: false
          },
        },
        series: [
          {
            name: '',
            type: 'bar',
            roundCap: false,
            barWidth: 60,
            z: 99,
            showBackground: true,
            backgroundStyle: {
              color: 'rgba(66, 66, 66, 0.3)',
            },
            data: [getvalue],
            coordinateSystem: 'polar',
            itemStyle: {
              normal: {
                color: '#25BFFF',
              }
            }
          },
          {
            name: '',
            type: 'bar',
            roundCap: false,
            barWidth: 60,
            data: [100],
            z: 98,
            coordinateSystem: 'polar',
            itemStyle: {
              normal: {
                color: '#cccccc',
              }
            }
          }
        ]
      }
    },
    initMonitorRedisData(monitorList, deviceId) {
      monitorList.map(v => {
        this.findMonitorTypeValue(v.monitorType, monitorList, deviceId);
      })
    },
    findMonitorTypeValue(monitorType, monitorList, deviceId) {
      let monitorObj = monitorList.find((item) => {
        return item.monitorType == monitorType;
      })
      if (+monitorObj.value) {
        this["deviceType" + deviceId]['monitorType' + monitorType] = +monitorObj.value
      } else {
        this["deviceType" + deviceId]['monitorType' + monitorType] = monitorObj.value
      }

    }
  }
}
</script>

<style lang="scss" scoped>
.parkingLot-box {
  padding-right: 20px;
  padding-left: 20px;
}
.parkingLot {
  font-size: 16px;
  text-align: center;
}
.bg {
  background-color: #f2f2f2;
  text-align: center;
  padding-top: 10px;
  padding-bottom: 10px;
  p {
    font-size: 14px;
    margin: 0;
    margin-bottom: 10px;
    color: #333;
    &:last-child {
      font-size: 16px;
      font-weight: 600;
    }
  }
  .skyBlue {
    color: #008080;
  }
  .green {
    color: #02a7f0;
  }
  .orange {
    color: #f59a23;
  }
}
.between {
  p {
    justify-content: space-between;
    display: flex;
    font-size: 14px;
    color: #8c8c8c;
  }
}
</style>